<template>
  <div class="business-page">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">{{ pageTitle }}</h1>
        <div class="header-divider"></div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="page-content">
      <div class="container">
        <!--        &lt;!&ndash; 加载状态 &ndash;&gt;-->
        <!--        <div v-if="isLoading" class="loading-container">-->
        <!--          <div class="loading-spinner"></div>-->
        <!--          <p class="loading-text">{{ t('common.loading') }}</p>-->
        <!--        </div>-->

        <!--        &lt;!&ndash; 错误状态 &ndash;&gt;-->
        <!--        <div v-else-if="errorMessage" class="error-container">-->
        <!--          <div class="error-icon">-->
        <!--            <el-icon size="60"><Warning /></el-icon>-->
        <!--          </div>-->
        <!--          <h3 class="error-title">{{ t('common.error') }}</h3>-->
        <!--          <p class="error-message">{{ errorMessage }}</p>-->
        <!--          <button class="retry-button" @click="fetchPageData">-->
        <!--            {{ t('common.retry') }}-->
        <!--          </button>-->
        <!--        </div>-->

        <!--        &lt;!&ndash; 富文本内容 &ndash;&gt;-->
        <!--        <div-->
        <!--          v-if="contentHtml"-->
        <!--          class="richtext-content"-->
        <!--          v-html="contentHtml"-->
        <!--        ></div>-->

        <!-- 切换按钮 -->
        <div class="section-switcher">
          <div
            v-for="(btn, index) in sectionButtons"
            :key="index"
            class="section-switch-btn"
            :class="{ active: activeSection === index }"
            @click="switchSection(index)"
          >
            {{ btn }}
          </div>
        </div>

        <!-- 我们的理念部分 -->
        <div v-if="activeSection === 0" class="philosophy-section">
          <div
            v-if="contentHtml"
            class="richtext-content"
            v-html="contentHtml"
          ></div>
          <div v-else class="empty-state">
            {{ t('common.no_content') }}
          </div>
        </div>

        <!-- 报告部分 -->
        <div v-else-if="activeSection === 1" class="reports-section">
          <div v-if="esgLoading" class="loading-container">
            <div class="loading-spinner"></div>
            <p class="loading-text">{{ t('common.loading') }}</p>
          </div>

          <div v-else-if="esgError" class="error-container">
            <div class="error-icon">
              <el-icon size="60"><Warning /></el-icon>
            </div>
            <h3 class="error-title">{{ t('common.error') }}</h3>
            <p class="error-message">{{ esgError }}</p>
            <button class="retry-button" @click="fetchESGInfo">
              {{ t('common.retry') }}
            </button>
          </div>

          <div v-else-if="esgInfo" class="esg-documents-section">
            <!-- 上下布局：上面是最新报告，下面是报告列表 -->
            <div class="reports-layout">
              <!-- 最新报告 -->
              <div v-if="esgInfo.latest_report" class="latest-report">
                <!--                <h3 class="section-title">{{ t('esg.latest_report') }}</h3>-->
                <div class="pdf-viewer">
                  <iframe
                    ref="pdfPreviewIframe"
                    :src="selectedReportFile || esgInfo.latest_report.file_path"
                    frameborder="0"
                    width="100%"
                    height="600"
                    class="pdf-preview-iframe"
                    style="border: 1px solid #eee;"
                    @load="handleIframeLoad('report')"
                  ></iframe>
                  <div class="pdf-download-btn">
                    <!--                    <el-button type="primary" @click="openPdfPreview(selectedReportFile || esgInfo.latest_report.file_path)">-->
                    <!--                      {{ t('esg.preview') }}-->
                    <!--                    </el-button>-->
                    <el-button icon="Download" size="large" type="success" @click="downloadFile(selectedReportFile || esgInfo.latest_report.file_path)">
                      {{ t('pages.download_pdf') }}
                    </el-button>
                  </div>
                </div>
              </div>

              <!-- 报告列表 -->
              <div v-if="esgInfo.report_list && esgInfo.report_list.length" class="report-list">
                <h3 class="section-title">{{ t('esg.historical_reports') }}</h3>
                <div class="file-items">
                  <div
                    v-for="(report, index) in esgInfo.report_list"
                    :key="index"
                    class="report-link"
                    @click="selectReport(report)"
                  >
                    <div class="report-content">
                      <div class="report-title">

                        <!--                        <el-tag-->
                        <!--                          v-if="extractYear(report.publish_time)"-->
                        <!--                          size="small"-->
                        <!--                          type="info"-->
                        <!--                          class="year-tag"-->
                        <!--                        >-->
                        <!--                          {{ extractYear(report.publish_time) }}-->
                        <!--                        </el-tag>-->
                        <span class="title-text">{{ report.title }}</span>
                      </div>
                      <div class="report-actions">
                        <el-button
                          link
                          type="success"
                          @click.stop="downloadFile(report.file_path)"
                          class="download-btn"
                        >
                          {{ t('common.download') }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="empty-files">
                {{ t('common.no_data') }}
              </div>
            </div>
          </div>
        </div>

        <!-- 政策部分 -->
        <div v-else-if="activeSection === 2" class="policies-section">
          <div v-if="esgLoading" class="loading-container">
            <div class="loading-spinner"></div>
            <p class="loading-text">{{ t('common.loading') }}</p>
          </div>

          <div v-else-if="esgError" class="error-container">
            <div class="error-icon">
              <el-icon size="60"><Warning /></el-icon>
            </div>
            <h3 class="error-title">{{ t('common.error') }}</h3>
            <p class="error-message">{{ esgError }}</p>
            <button class="retry-button" @click="fetchESGInfo">
              {{ t('common.retry') }}
            </button>
          </div>

          <div v-else-if="esgInfo" class="esg-documents-section">
            <div class="reports-layout">
              <!-- 最新政策 -->
              <div v-if="esgInfo.latest_policy" class="latest-report">
                <div class="pdf-viewer">
                  <iframe
                    ref="pdfPreviewPolicyIframe"
                    :src="selectedPolicyFile || esgInfo.latest_policy.file_path"
                    frameborder="0"
                    width="100%"
                    height="600"
                    class="pdf-preview-iframe"
                    @load="handleIframeLoad('policy')"
                    style="border: 1px solid #eee;"
                  ></iframe>
                  <div class="pdf-download-btn">
                    <el-button icon="Download" size="large" type="success" @click="downloadFile(selectedPolicyFile || esgInfo.latest_policy.file_path)">
                      {{ t('pages.download_pdf') }}
                    </el-button>
                  </div>
                </div>
              </div>

              <!-- 政策列表 -->
              <div v-if="esgInfo.policy_list && esgInfo.policy_list.length" class="report-list">
                <h3 class="section-title">{{ t('esg.historical_policies') }}</h3>
                <div class="file-items">
                  <div
                    v-for="(policy, index) in esgInfo.policy_list"
                    :key="index"
                    class="report-link"
                    @click="selectPolicy(policy)"
                  >
                    <div class="report-content">
                      <div class="report-title">
                        <span class="title-text">{{ policy.title }}</span>
                      </div>
                      <div class="report-actions">
                        <el-button
                          link
                          type="success"
                          @click.stop="downloadFile(policy.file_path)"
                          class="download-btn"
                        >
                          {{ t('common.download') }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="empty-files">
                {{ t('common.no_data') }}
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div
          v-if="!isLoading && !errorMessage && !contentHtml"
          class="empty-state"
        >
          <div class="empty-icon">
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M40 70C56.5685 70 70 56.5685 70 40C70 23.4315 56.5685 10 40 10C23.4315 10 10 23.4315 10 40C10 56.5685 23.4315 70 40 70Z"
                stroke="var(--el-color-primary-light-8)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M40 30V40"
                stroke="var(--el-color-primary-light-6)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M40 50H40.025"
                stroke="var(--el-color-primary-light-6)"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h3 class="empty-title">{{ t('common.no_data') }}</h3>
          <p class="empty-description">{{ t('common.no_content') }}</p>
        </div>
      </div>
    </div>

    <!-- PDF预览弹窗 -->
    <el-dialog
      v-model="pdfDialogVisible"
      :title="t('esg.preview')"
      width="90%"
      top="5vh"
    >
      <iframe
        :src="currentPdfUrl"
        frameborder="0"
        width="100%"
        height="70vh"
        style="border: 1px solid #eee;"
      ></iframe>
      <template #footer>
        <div class="pdf-download-btn">
          <!--          <el-button @click="pdfDialogVisible = false">{{ t('common.close') }}</el-button>-->
          <el-button icon="Download" type="primary" @click="downloadFile(currentPdfUrl)">{{ t('pages.download_pdf') }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, nextTick, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'
import { Warning, Download } from '@element-plus/icons-vue'
import { getSinglePageContent, getESGInfo } from "@/assets/api/website";

// 使用 i18n
const { locale, t } = useI18n()
// 新增：标记是否需要滚动到顶部
const shouldScrollReportToTop = ref(false)
const shouldScrollPolicyToTop = ref(false)
// 响应式数据
const pageData = ref(null)
const isLoading = ref(false)
const errorMessage = ref('')
const esgInfo = ref(null)
const esgLoading = ref(false)
const esgError = ref('')
const pdfDialogVisible = ref(false)
const currentPdfUrl = ref('')
const activeSection = ref(0)
const selectedReportFile = ref('')
const selectedPolicyFile = ref('')
const pdfPreviewIframe = ref(null)
const pdfPreviewPolicyIframe = ref(null)

// 计算属性
const pageTitle = computed(() => {
  return pageData.value?.page_name || t('menu.explosives')
})

const contentHtml = computed(() => {
  return pageData.value?.content?.richtext || ''
})

const switchSection = (index) => {
  activeSection.value = index
}

const sectionButtons = computed(() => [
  t('esg.our_philosophy'),
  t('esg.reports'),
  t('esg.policies')
])

const selectReport = (report) => {
  selectedReportFile.value = report.file_path
  shouldScrollReportToTop.value = true // 标记需要滚动

  // 先滚动到 iframe 所在区域
  nextTick(() => {
    if (pdfPreviewIframe.value) {
      // 修复：移除不合法的 margin 参数，使用正确的 scrollIntoView 配置
      pdfPreviewIframe.value.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      })

      // 备用方案：直接修改父容器滚动（如果 iframe 滚动失败）
      const container = pdfPreviewIframe.value.parentElement
      if (container) {
        container.scrollTop = 0
      }
    }
  })
}

const selectPolicy = (policy) => {
  selectedPolicyFile.value = policy.file_path
  shouldScrollPolicyToTop.value = true // 标记需要滚动

  nextTick(() => {
    if (pdfPreviewPolicyIframe.value) {
      pdfPreviewPolicyIframe.value.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      })

      // 备用方案
      const container = pdfPreviewPolicyIframe.value.parentElement
      if (container) {
        container.scrollTop = 0
      }
    }
  })
}
const handleIframeLoad = (type) => {
  try {
    let iframeRef = null
    let shouldScroll = false

    if (type === 'report') {
      iframeRef = pdfPreviewIframe.value
      shouldScroll = shouldScrollReportToTop.value
      shouldScrollReportToTop.value = false
    } else if (type === 'policy') {
      iframeRef = pdfPreviewPolicyIframe.value
      shouldScroll = shouldScrollPolicyToTop.value
      shouldScrollPolicyToTop.value = false
    }

    if (iframeRef && shouldScroll) {
      // 方法1：尝试直接操作 iframe 内部滚动（同源情况下生效）
      const iframeWindow = iframeRef.contentWindow
      if (iframeWindow) {
        iframeWindow.scrollTo(0, 0)

        // 兼容不同的 PDF 查看器
        const iframeDoc = iframeWindow.document
        if (iframeDoc) {
          iframeDoc.documentElement.scrollTop = 0
          iframeDoc.body.scrollTop = 0
        }
      }
    }
  } catch (error) {
    // 跨域时会触发错误，这里静默处理
    console.debug('无法操作 iframe 滚动（跨域限制）:', error)
  }
}
watch(selectedReportFile, (newUrl) => {
  if (newUrl) {
    // 延迟 500ms 再次尝试（应对 PDF 加载慢的情况）
    setTimeout(() => {
      try {
        const iframeWindow = pdfPreviewIframe.value?.contentWindow
        if (iframeWindow) {
          iframeWindow.scrollTo(0, 0)
        }
      } catch (e) { /* 忽略跨域错误 */ }
    }, 500)
  }
})
watch(selectedPolicyFile, (newUrl) => {
  if (newUrl) {
    setTimeout(() => {
      try {
        const iframeWindow = pdfPreviewPolicyIframe.value?.contentWindow
        if (iframeWindow) {
          iframeWindow.scrollTo(0, 0)
        }
      } catch (e) { /* 忽略跨域错误 */ }
    }, 500)
  }
})
// 提取年份
const extractYear = (dateString) => {
  if (!dateString) return ''
  // 尝试从日期字符串中提取年份
  const match = dateString.match(/\d{4}/)
  return match ? match[0] : ''
}

// 获取页面数据
const fetchPageData = async () => {
  isLoading.value = true
  errorMessage.value = ''

  try {
    // 使用当前的语言
    const currentLocale = locale.value

    const response = await getSinglePageContent({
      lang: currentLocale,
      path: '/esg' // 使用当前路由路径
    })

    if (response) {
      pageData.value = response
    } else {
      pageData.value = null
    }
  } catch (error) {
    console.error('获取页面数据失败:', error)
    errorMessage.value = t('common.load_failed')
  } finally {
    isLoading.value = false
  }
}

// 获取ESG信息
const fetchESGInfo = async () => {
  esgLoading.value = true
  esgError.value = ''

  try {
    const currentLocale = locale.value
    const response = await getESGInfo({ lang: currentLocale})
    if (response) {
      esgInfo.value = response
    } else {
      esgInfo.value = null
    }
  } catch (error) {
    console.error('获取ESG信息失败:', error)
    esgError.value = t('common.load_failed')
  } finally {
    esgLoading.value = false
  }
}

// 预览PDF
const openPdfPreview = (url) => {
  currentPdfUrl.value = url
  pdfDialogVisible.value = true
}

// 下载文件
const downloadFile = (url) => {
  const link = document.createElement('a')
  link.href = url
  link.download = url.split('/').pop() || 'document.pdf'
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// 监听语言变化，重新加载数据
watch(locale, () => {
  fetchPageData()
  fetchESGInfo()
})

// 当esgInfo更新时，设置默认选中的报告文件
watch(esgInfo, (newInfo) => {
  if (newInfo?.latest_report?.file_path) {
    selectedReportFile.value = newInfo.latest_report.file_path
  }
  if (newInfo?.latest_policy?.file_path) {
    selectedPolicyFile.value = newInfo.latest_policy.file_path
  }
}, { immediate: true })

// 组件挂载时获取数据
onMounted(() => {
  fetchPageData()
  fetchESGInfo()
})
</script>

<style scoped lang="scss">

// 导入全局样式变量
@import '@/assets/css/business.scss';
.pdf-preview-iframe {
  scroll-margin-top: 100px;
}
// 切换按钮样式
.section-switcher {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 20px 30px;
  //background: rgba($primary-color, 0.03);
  border-bottom: 1px solid rgba($primary-color, 0.1);
  //margin-top: 40px;

  @media (max-width: 768px) {
    padding: 16px 24px;
    gap: 10px;
  }

  @media (max-width: 480px) {
    padding: 12px 20px;
    gap: 8px;
  }
}

.section-switch-btn {
  padding: 10px 20px;
  background: white;
  border: 1px solid rgba($primary-color, 0.4);
  border-radius: 8px;
  color: #333;
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    border-color: rgba($primary-color, 0.7);
    background: rgba($primary-color, 0.05);
    transform: translateY(-2px);
  }

  &.active {
    background: $primary-color;
    color: white;
    border-color: $primary-color;
    box-shadow: 0 4px 8px rgba($primary-color, 0.2);
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 0.875rem;
  }

  @media (max-width: 480px) {
    padding: 6px 12px;
    font-size: 0.8125rem;
  }
}

.pdf-download-btn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 15px;
  :deep(.el-button){
    padding-left: 10px;
    padding-right: 10px;
  }
}
.esg-documents-section {
  //margin-top: 60px;
  padding-top: 40px;
  border-top: 1px solid #eee;
  .section-title {
    font-size: 20px;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid $primary-color;
  }

  .pdf-preview {
    .pdf-viewer {
      background: #fafafa;
      border-radius: 8px;
      padding: 20px;
      border: 1px solid #eee;

      .pdf-actions {
        margin-top: 20px;
        display: flex;
        gap: 15px;
      }
    }
  }

  .report-list {
    //background: #fafafa;
    border-radius: 8px;
    padding: 20px;
    //border: 1px solid #eee;

    .file-items {
      .report-link {
        color: inherit;
        background: transparent;
        display: block;
        padding: 12px 0;
        border-bottom: 1px solid #eee;
        cursor: pointer; /* 关键：手型鼠标 */
        text-decoration: none;
        transition: background-color 0.3s ease;

        &:last-child {
          border-bottom: none;
        }

        /* 悬停效果，模拟 el-link 的 primary 类型悬停 */
        &:hover {
          background-color: rgba($primary-color, 0.05);

          .report-content {
            .report-title {
              .title-text {
                color: $primary-color; /* 文字变蓝 */
              }
            }
          }
        }

        .report-content {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .report-title {
            display: flex;
            align-items: center;
            gap: 10px;
            flex: 1;
            margin-right: 15px; /* 防止标题贴到下载按钮 */

            .title-text {
              font-size: 14px;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              transition: color 0.3s ease;
            }

            .year-tag {
              flex-shrink: 0; /* 防止 Tag 被挤压 */
            }
          }

          .report-actions {
            flex-shrink: 0;

            .download-btn {
              margin-left: 10px;
            }
          }
        }
      }
    }

    .policy-file-section {
      .el-empty {
        margin: 40px 0;
      }
    }

    .empty-files {
      text-align: center;
      color: #999;
      padding: 30px 0;
      font-size: 14px;
    }
  }
}

@media (max-width: 768px) {
  .esg-documents-section {
    .pdf-preview {
      margin-bottom: 30px;
    }
  }
}
</style>